export const MyPagesRoutes = {
	News: "news",
	Profile: "profile",
	User: "user",
	Schedule: "schedule",
	TimeReport: "timereport",
	Salary: "salary",
	Messages: "messages",
	Tip: "tip",
	Documents: "documents",
	Clock: "clock",
	Menu: "menu",
	Feedback: "feedback",
	PeriodOverview: "periodoverview",
	Colleagues: "colleagues",
} as const;
